import { useState, useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';

const resultsHtml = `
    <div class="container">
        <div class="header">
            <h1>Complete Trade Log</h1>
            <div class="subtitle">AI Daily Bias 0DTE Options Strategy | VIX >= 16 Filter</div>
            <div class="subtitle">93 Trades | 2025 Backtest</div>
        </div>

        <div class="content">
            <p style="margin: 20px; font-size: 1.1em;"><a href="/backtesting/ai-bias?key=ai-bias-2025" style="color: #667eea; text-decoration: none; font-weight: bold;">← Back to Main Report</a></p>

            <!-- Complete Trade Log -->
            <div class="section">
                <h2>Complete Trade Log</h2>
                <div class="info-box">
                    <p><strong>All 93 trades</strong> executed in 2025 with AI bias reasoning.</p>
                </div>
                <table>
                    <thead>
                        <tr>
                            <th>Date</th>
                            <th>Bias</th>
                            <th>Conf</th>
                            <th>VIX</th>
                            <th>Entry</th>
                            <th>Exit</th>
                            <th>Move %</th>
                            <th>Net P&L</th>
                            <th>AI Reasoning</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>2025-01-03</td>
                            <td>BULLISH</td>
                            <td>72%</td>
                            <td>17.9</td>
                            <td>$511.92</td>
                            <td>$519.07</td>
                            <td class="positive">+1.40%</td>
                            <td class="positive">$+396.37</td>
                            <td style="font-size: 0.85em;">Price opened at 513.35 and has established a clear uptrend, reaching highs of 517.97 with the current price at 516.98. The session shows a gap up of +1.50 from previous close of 511.85 (+0.29%), which...</td>
                        </tr>
                        <tr>
                            <td>2025-01-06</td>
                            <td>BULLISH</td>
                            <td>72%</td>
                            <td>16.1</td>
                            <td>$520.27</td>
                            <td>$524.83</td>
                            <td class="positive">+0.88%</td>
                            <td class="positive">$+167.54</td>
                            <td style="font-size: 0.85em;">QQQ gapped up significantly from Friday's close of $519.07 to open at $524.02 (+$4.95, +0.95%), indicating strong overnight bullish sentiment. Pre-market price action shows consolidation between $525-...</td>
                        </tr>
                        <tr>
                            <td>2025-01-07</td>
                            <td>BEARISH</td>
                            <td>72%</td>
                            <td>16.0</td>
                            <td>$524.70</td>
                            <td>$516.29</td>
                            <td class="positive">-1.60%</td>
                            <td class="positive">$+552.88</td>
                            <td style="font-size: 0.85em;">Price opened at 525.59 and has declined steadily to 516.83, representing a -1.67% intraday drop from open and -1.52% from previous close of 524.83. The session shows consistent lower highs and lower l...</td>
                        </tr>
                        <tr>
                            <td>2025-01-10</td>
                            <td>BEARISH</td>
                            <td>72%</td>
                            <td>17.7</td>
                            <td>$513.62</td>
                            <td>$506.58</td>
                            <td class="positive">-1.37%</td>
                            <td class="positive">$+430.54</td>
                            <td style="font-size: 0.85em;">QQQ gapped down significantly from previous close of 513.93 to open at 511.48 (-0.48%), then continued selling to current price of 505.84 (-1.57% from previous close). Price action shows consistent lo...</td>
                        </tr>
                        <tr>
                            <td>2025-01-15</td>
                            <td>BULLISH</td>
                            <td>72%</td>
                            <td>18.7</td>
                            <td>$505.44</td>
                            <td>$517.33</td>
                            <td class="positive">+2.35%</td>
                            <td class="positive">$+926.44</td>
                            <td style="font-size: 0.85em;">QQQ opened with a significant gap up of $7.45 (+1.47%) from previous close of $505.90 to pre-market open of $513.35. Early pre-market session (6:30-7:15 AM) showed strong momentum with price advancing...</td>
                        </tr>
                        <tr>
                            <td>2025-01-17</td>
                            <td>BULLISH</td>
                            <td>72%</td>
                            <td>16.6</td>
                            <td>$514.02</td>
                            <td>$521.93</td>
                            <td class="positive">+1.54%</td>
                            <td class="positive">$+481.29</td>
                            <td style="font-size: 0.85em;">QQQ gapped up $9.96 (1.94%) from previous close of $512.89, opening at $522.85. Price has consolidated in a tight range between $519.10 and $523.05 over the pre-market session, showing buyers defendin...</td>
                        </tr>
                        <tr>
                            <td>2025-01-28</td>
                            <td>BULLISH</td>
                            <td>72%</td>
                            <td>17.9</td>
                            <td>$517.42</td>
                            <td>$521.64</td>
                            <td class="positive">+0.82%</td>
                            <td class="positive">$+150.25</td>
                            <td style="font-size: 0.85em;">Price opened at 515.22 and has steadily climbed to 521.18, representing a +1.16% gain from session open. The recovery from yesterday's wide-range day (502.32 low to 529.23 high) with today's gap-down ...</td>
                        </tr>
                        <tr>
                            <td>2025-02-05</td>
                            <td>BULLISH</td>
                            <td>72%</td>
                            <td>17.2</td>
                            <td>$519.82</td>
                            <td>$527.18</td>
                            <td class="positive">+1.42%</td>
                            <td class="positive">$+402.81</td>
                            <td style="font-size: 0.85em;">Price action shows strong bullish momentum from pre-market through early session. QQQ opened at 521.82, below previous close of 522.78 (gap down of -0.96), but has rallied consistently throughout the ...</td>
                        </tr>
                        <tr>
                            <td>2025-02-10</td>
                            <td>BULLISH</td>
                            <td>72%</td>
                            <td>16.5</td>
                            <td>$525.64</td>
                            <td>$528.40</td>
                            <td class="negative">+0.53%</td>
                            <td class="negative">$-78.68</td>
                            <td style="font-size: 0.85em;">Strong overnight gap up of $5.12 (+0.98%) from previous close of $521.85 to pre-market open at $527.22. Price established higher lows throughout pre-market session, climbing from $526.75 low to $530.3...</td>
                        </tr>
                        <tr>
                            <td>2025-02-12</td>
                            <td>BULLISH</td>
                            <td>72%</td>
                            <td>16.0</td>
                            <td>$528.24</td>
                            <td>$530.52</td>
                            <td class="negative">+0.43%</td>
                            <td class="negative">$-68.24</td>
                            <td style="font-size: 0.85em;">QQQ opened with a significant gap down of $6.17 (-1.17%) from previous close of $528.47 to $522.30, but has shown strong recovery throughout pre-market. Price has rallied from the session low of $521....</td>
                        </tr>
                        <tr>
                            <td>2025-02-24</td>
                            <td>BEARISH</td>
                            <td>72%</td>
                            <td>18.2</td>
                            <td>$528.43</td>
                            <td>$520.14</td>
                            <td class="positive">-1.57%</td>
                            <td class="positive">$+465.64</td>
                            <td style="font-size: 0.85em;">QQQ opened Monday with a significant gap down from Friday's close of $525.98 to $527.88 pre-market, then sold off aggressively in the first 30 minutes from $527.54 to a low of $520.19. The initial sel...</td>
                        </tr>
                        <tr>
                            <td>2025-02-25</td>
                            <td>BEARISH</td>
                            <td>72%</td>
                            <td>19.0</td>
                            <td>$518.20</td>
                            <td>$515.68</td>
                            <td class="negative">-0.49%</td>
                            <td class="negative">$-82.22</td>
                            <td style="font-size: 0.85em;">QQQ gapped down significantly from previous close of $520.14, opening at $519.24 and immediately selling off. The session has established a clear downtrend with price declining from $519.24 to current...</td>
                        </tr>
                        <tr>
                            <td>2025-02-27</td>
                            <td>BEARISH</td>
                            <td>72%</td>
                            <td>19.1</td>
                            <td>$516.77</td>
                            <td>$500.56</td>
                            <td class="positive">-3.14%</td>
                            <td class="positive">$+1,330.64</td>
                            <td style="font-size: 0.85em;">QQQ opened significantly higher at 518.13 but has experienced sustained selling pressure throughout the pre-market and early session, dropping from the overnight high of 518.79 to current levels aroun...</td>
                        </tr>
                        <tr>
                            <td>2025-03-04</td>
                            <td>BEARISH</td>
                            <td>72%</td>
                            <td>22.8</td>
                            <td>$498.47</td>
                            <td>$498.84</td>
                            <td class="negative">+0.07%</td>
                            <td class="negative">$-302.38</td>
                            <td style="font-size: 0.85em;">QQQ gapped down significantly from previous close of $499.17, opening pre-market at $494.18 (-1.0% gap). Price immediately sold off to session low of $487.74 at 07:20, demonstrating strong selling pre...</td>
                        </tr>
                        <tr>
                            <td>2025-03-06</td>
                            <td>BEARISH</td>
                            <td>72%</td>
                            <td>21.9</td>
                            <td>$499.89</td>
                            <td>$490.33</td>
                            <td class="positive">-1.91%</td>
                            <td class="positive">$+663.77</td>
                            <td style="font-size: 0.85em;">QQQ opened with a significant gap down from previous close of 500.41 to 493.69 (-1.34%). After an initial recovery attempt that pushed price to intraday high of 498.58, the market has sold off aggress...</td>
                        </tr>
                        <tr>
                            <td>2025-03-07</td>
                            <td>BEARISH</td>
                            <td>72%</td>
                            <td>24.9</td>
                            <td>$490.43</td>
                            <td>$490.90</td>
                            <td class="negative">+0.10%</td>
                            <td class="negative">$-297.56</td>
                            <td style="font-size: 0.85em;">Price opened at 487.16 (gap down from previous close of 490.33, a -$3.17 or -0.65% gap). Early session showed brief recovery attempt to 492.07 high, but aggressive selling drove price down to intraday...</td>
                        </tr>
                        <tr>
                            <td>2025-03-10</td>
                            <td>BEARISH</td>
                            <td>78%</td>
                            <td>23.4</td>
                            <td>$488.69</td>
                            <td>$469.42</td>
                            <td class="positive">-3.94%</td>
                            <td class="positive">$+1,661.49</td>
                            <td style="font-size: 0.85em;">QQQ opened with a significant gap down of -$8.94 (-1.82%) from Friday's close of $490.90 to pre-market open of $483.45. Price action shows consistent selling pressure throughout pre-market session, de...</td>
                        </tr>
                        <tr>
                            <td>2025-03-13</td>
                            <td>BEARISH</td>
                            <td>72%</td>
                            <td>24.2</td>
                            <td>$474.28</td>
                            <td>$470.94</td>
                            <td class="positive">-0.70%</td>
                            <td class="positive">$+18.13</td>
                            <td style="font-size: 0.85em;">Price gapped down $2.66 from previous close of 478.91, opening at 476.25. Continuous selling pressure has pushed price to session lows near 469.69, establishing a clear lower-high, lower-low structure...</td>
                        </tr>
                        <tr>
                            <td>2025-03-14</td>
                            <td>BULLISH</td>
                            <td>72%</td>
                            <td>24.7</td>
                            <td>$472.01</td>
                            <td>$479.18</td>
                            <td class="positive">+1.52%</td>
                            <td class="positive">$+431.49</td>
                            <td style="font-size: 0.85em;">QQQ opened on 3/14 at $473.73 with a gap up from previous close of $470.94 (+$2.79, +0.59%). Price rallied strongly in early pre-market to session high of $479.47 before consolidating. Current price o...</td>
                        </tr>
                        <tr>
                            <td>2025-03-18</td>
                            <td>BEARISH</td>
                            <td>72%</td>
                            <td>20.5</td>
                            <td>$481.43</td>
                            <td>$474.78</td>
                            <td class="positive">-1.38%</td>
                            <td class="positive">$+329.84</td>
                            <td style="font-size: 0.85em;">QQQ opened at 479.41 and has declined steadily throughout pre-market, currently trading at 475.85. The overnight gap down of -3.13 points (-0.65%) from previous close of 482.54 signals institutional d...</td>
                        </tr>
                        <tr>
                            <td>2025-03-24</td>
                            <td>BULLISH</td>
                            <td>72%</td>
                            <td>19.3</td>
                            <td>$485.66</td>
                            <td>$490.20</td>
                            <td class="positive">+0.93%</td>
                            <td class="positive">$+125.11</td>
                            <td style="font-size: 0.85em;">Strong gap-up open of +5.63 points (+1.17%) from previous close of 481.61 to 487.74 demonstrates significant overnight bullish sentiment. Price has maintained above the gap level throughout the pre-ma...</td>
                        </tr>
                        <tr>
                            <td>2025-03-26</td>
                            <td>BEARISH</td>
                            <td>72%</td>
                            <td>17.1</td>
                            <td>$493.28</td>
                            <td>$483.10</td>
                            <td class="positive">-2.06%</td>
                            <td class="positive">$+690.69</td>
                            <td style="font-size: 0.85em;">Price opened at 492.30 and has been in a clear downtrend throughout the pre-market session, dropping to 486.74 (current). This represents a -1.54% decline from previous close of 494.28. The gap down o...</td>
                        </tr>
                        <tr>
                            <td>2025-03-28</td>
                            <td>BEARISH</td>
                            <td>78%</td>
                            <td>18.7</td>
                            <td>$478.64</td>
                            <td>$466.90</td>
                            <td class="positive">-2.45%</td>
                            <td class="positive">$+919.52</td>
                            <td style="font-size: 0.85em;">Strong bearish momentum evident from price action. QQQ opened at 479.81 (gap down from previous close of 480.91) and has declined consistently to 469.95, representing a -2.3% intraday decline. The ses...</td>
                        </tr>
                        <tr>
                            <td>2025-03-31</td>
                            <td>BEARISH</td>
                            <td>72%</td>
                            <td>21.6</td>
                            <td>$464.66</td>
                            <td>$466.65</td>
                            <td class="negative">+0.43%</td>
                            <td class="negative">$-282.10</td>
                            <td style="font-size: 0.85em;">Strong bearish gap down from Friday's close of $466.90 to Monday's open at $461.92 (-1.07% gap). Price established intraday low of $457.33 before recovering to current level around $464.81. The Friday...</td>
                        </tr>
                        <tr>
                            <td>2025-04-01</td>
                            <td>BULLISH</td>
                            <td>72%</td>
                            <td>22.3</td>
                            <td>$466.94</td>
                            <td>$473.63</td>
                            <td class="positive">+1.43%</td>
                            <td class="positive">$+379.54</td>
                            <td style="font-size: 0.85em;">Price opened at 467.30 above previous close of 466.65 (+0.14% gap up) and has since rallied to 473.30 high before pulling back to 471.49 current. The session shows a clear bullish structure with highe...</td>
                        </tr>
                        <tr>
                            <td>2025-04-02</td>
                            <td>BULLISH</td>
                            <td>72%</td>
                            <td>21.8</td>
                            <td>$471.00</td>
                            <td>$455.20</td>
                            <td class="negative">-3.35%</td>
                            <td class="negative">$-285.90</td>
                            <td style="font-size: 0.85em;">Price opened at 466.12 with a significant gap down from previous close of 473.63 (-1.59%), but has shown strong recovery throughout pre-market and early session. Current price at 476.58 represents a c...</td>
                        </tr>
                        <tr>
                            <td>2025-04-04</td>
                            <td>BEARISH</td>
                            <td>78%</td>
                            <td>30.0</td>
                            <td>$450.00</td>
                            <td>$422.20</td>
                            <td class="positive">-6.18%</td>
                            <td class="positive">$+2,506.70</td>
                            <td style="font-size: 0.85em;">QQQ opened with a significant overnight gap down of $11.72 (-2.6%) from previous close of $449.99 to open at $438.14. The session has continued lower with persistent selling pressure, establishing low...</td>
                        </tr>
                        <tr>
                            <td>2025-04-07</td>
                            <td>BEARISH</td>
                            <td>72%</td>
                            <td>45.3</td>
                            <td>$402.67</td>
                            <td>$428.86</td>
                            <td class="negative">+6.50%</td>
                            <td class="negative">$-244.90</td>
                            <td style="font-size: 0.85em;">QQQ gapped down significantly from previous close of $422.20, opening at $408.66 on April 7th - a gap of approximately $13.54 or -3.2%. The session shows extreme volatility with a massive intraday ran...</td>
                        </tr>
                        <tr>
                            <td>2025-04-09</td>
                            <td>BULLISH</td>
                            <td>72%</td>
                            <td>52.3</td>
                            <td>$418.66</td>
                            <td>$466.06</td>
                            <td class="positive">+11.32%</td>
                            <td class="positive">$+4,451.50</td>
                            <td style="font-size: 0.85em;">Strong gap up from previous close of $410.18 to pre-market open of $415.57 (+1.3%). Price rallied to session high of $424.94 before consolidating in the $417-$423 range. The gap has held with no attem...</td>
                        </tr>
                        <tr>
                            <td>2025-04-10</td>
                            <td>BEARISH</td>
                            <td>82%</td>
                            <td>33.6</td>
                            <td>$458.61</td>
                            <td>$443.19</td>
                            <td class="positive">-3.36%</td>
                            <td class="positive">$+1,302.53</td>
                            <td style="font-size: 0.85em;">Strong bearish momentum evident from price action: QQQ opened at 453.56 and has declined to 434.90, a drop of $18.66 (-4.1%) in pre-market/early session. The previous day's close was 466.06, meaning w...</td>
                        </tr>
                        <tr>
                            <td>2025-04-14</td>
                            <td>BEARISH</td>
                            <td>72%</td>
                            <td>37.6</td>
                            <td>$462.66</td>
                            <td>$455.27</td>
                            <td class="positive">-1.60%</td>
                            <td class="positive">$+492.27</td>
                            <td style="font-size: 0.85em;">Price action shows significant weakness from the pre-market gap up open at 464.46 to current levels around 454.47. Despite opening with a +10.34 gap above previous close of 454.12, the market has sold...</td>
                        </tr>
                        <tr>
                            <td>2025-04-21</td>
                            <td>BEARISH</td>
                            <td>72%</td>
                            <td>29.6</td>
                            <td>$438.92</td>
                            <td>$435.10</td>
                            <td class="positive">-0.87%</td>
                            <td class="positive">$+123.35</td>
                            <td style="font-size: 0.85em;">QQQ opened significantly below previous close ($445.64) at $438.23, creating a substantial gap down of $7.41 (-1.66%). Price action throughout pre-market shows consistent selling pressure with lower h...</td>
                        </tr>
                        <tr>
                            <td>2025-04-22</td>
                            <td>BULLISH</td>
                            <td>78%</td>
                            <td>33.8</td>
                            <td>$436.72</td>
                            <td>$453.68</td>
                            <td class="positive">+3.88%</td>
                            <td class="positive">$+1,402.67</td>
                            <td style="font-size: 0.85em;">Strong bullish momentum evident from price action. QQQ opened at 438.82 and has steadily climbed to 447.12, gaining +8.30 points (+1.9%) from pre-market open. Price has made consistent higher highs an...</td>
                        </tr>
                        <tr>
                            <td>2025-04-24</td>
                            <td>BULLISH</td>
                            <td>72%</td>
                            <td>28.5</td>
                            <td>$451.74</td>
                            <td>$469.58</td>
                            <td class="positive">+3.95%</td>
                            <td class="positive">$+1,483.66</td>
                            <td style="font-size: 0.85em;">Strong gap-up opening from previous close of $455.63 to $456.48 (+0.85 or +0.19%). Price has rallied consistently throughout pre-market from $456.77 to current $464.92, representing a +1.78% gain from...</td>
                        </tr>
                        <tr>
                            <td>2025-04-25</td>
                            <td>BULLISH</td>
                            <td>72%</td>
                            <td>26.5</td>
                            <td>$469.75</td>
                            <td>$472.99</td>
                            <td class="positive">+0.69%</td>
                            <td class="positive">$+14.25</td>
                            <td style="font-size: 0.85em;">Strong bullish momentum established from previous session's +4.1% rally (449.72 low to 469.58 close). Current pre-market/early session shows price consolidating near highs with higher lows pattern for...</td>
                        </tr>
                        <tr>
                            <td>2025-04-28</td>
                            <td>BEARISH</td>
                            <td>72%</td>
                            <td>24.8</td>
                            <td>$470.22</td>
                            <td>$472.48</td>
                            <td class="negative">+0.48%</td>
                            <td class="negative">$-285.43</td>
                            <td style="font-size: 0.85em;">Price has declined from the pre-market high of 474.808 to current 466.55, a drop of $8.26 (1.74%). The session opened with a small gap up from Friday's close of 472.994 to 473.03, but immediately face...</td>
                        </tr>
                        <tr>
                            <td>2025-05-02</td>
                            <td>BULLISH</td>
                            <td>72%</td>
                            <td>24.6</td>
                            <td>$481.99</td>
                            <td>$488.92</td>
                            <td class="positive">+1.44%</td>
                            <td class="positive">$+399.51</td>
                            <td style="font-size: 0.85em;">Strong overnight gap up from previous close of 479.00 to pre-market open at 486.54 (+1.57%). Price has maintained a steady uptrend throughout pre-market session, establishing higher lows from 484.83 t...</td>
                        </tr>
                        <tr>
                            <td>2025-05-08</td>
                            <td>BULLISH</td>
                            <td>78%</td>
                            <td>23.5</td>
                            <td>$488.15</td>
                            <td>$487.98</td>
                            <td class="negative">-0.03%</td>
                            <td class="negative">$-296.19</td>
                            <td style="font-size: 0.85em;">Strong bullish momentum evident from price action. Gap up open at 488.53 vs previous close of 483.37 (+5.16 points, +1.07%). After early consolidation between 485-487, price broke out decisively at 08...</td>
                        </tr>
                        <tr>
                            <td>2025-05-12</td>
                            <td>BULLISH</td>
                            <td>72%</td>
                            <td>21.9</td>
                            <td>$497.33</td>
                            <td>$506.80</td>
                            <td class="positive">+1.90%</td>
                            <td class="positive">$+678.30</td>
                            <td style="font-size: 0.85em;">Massive overnight gap up of +$16.31 (+3.3%) from previous close of $487.92 to pre-market open at $506.99. Despite initial selling pressure that drove price from $507.06 high down to $501.48 low (conso...</td>
                        </tr>
                        <tr>
                            <td>2025-05-13</td>
                            <td>BULLISH</td>
                            <td>72%</td>
                            <td>18.4</td>
                            <td>$505.37</td>
                            <td>$516.18</td>
                            <td class="positive">+2.14%</td>
                            <td class="positive">$+811.48</td>
                            <td style="font-size: 0.85em;">Strong bullish gap-up of +2.36 points (+0.47%) from previous close of 506.80 to pre-market open at 509.16. Price has maintained upward momentum throughout the session, climbing from 509.99 to 516.36 (...</td>
                        </tr>
                        <tr>
                            <td>2025-05-14</td>
                            <td>BULLISH</td>
                            <td>72%</td>
                            <td>18.2</td>
                            <td>$516.49</td>
                            <td>$518.15</td>
                            <td class="negative">+0.32%</td>
                            <td class="negative">$-98.19</td>
                            <td style="font-size: 0.85em;">QQQ gapped up $0.59 (0.11%) from previous close of $516.18 to open at $516.77, immediately pushing to session high of $518.92 within the first 10 minutes. Price has consolidated in a tight range betwe...</td>
                        </tr>
                        <tr>
                            <td>2025-05-15</td>
                            <td>BULLISH</td>
                            <td>72%</td>
                            <td>18.6</td>
                            <td>$516.97</td>
                            <td>$519.17</td>
                            <td class="negative">+0.43%</td>
                            <td class="negative">$-96.48</td>
                            <td style="font-size: 0.85em;">Price action shows clear bullish structure: opened at 516.52 (gap down from previous close 518.15), found support at 515.17 intraday low, and has steadily climbed to 519.85. The market has recovered t...</td>
                        </tr>
                        <tr>
                            <td>2025-05-19</td>
                            <td>BULLISH</td>
                            <td>72%</td>
                            <td>17.2</td>
                            <td>$514.14</td>
                            <td>$522.42</td>
                            <td class="positive">+1.61%</td>
                            <td class="positive">$+530.22</td>
                            <td style="font-size: 0.85em;">Strong gap-up open from previous close of $514.62 to $515.38 (+0.15%) with sustained buying pressure throughout pre-market and early session. Price has rallied from $514.24 low to current $520.78, a g...</td>
                        </tr>
                        <tr>
                            <td>2025-05-21</td>
                            <td>BULLISH</td>
                            <td>72%</td>
                            <td>18.1</td>
                            <td>$517.79</td>
                            <td>$512.96</td>
                            <td class="negative">-0.93%</td>
                            <td class="negative">$-313.97</td>
                            <td style="font-size: 0.85em;">Strong gap recovery pattern observed. Price opened at 516.27 (gap down from previous close of 519.84) and has recovered to 522.31, representing a +1.17% intraday recovery. Consistent higher lows estab...</td>
                        </tr>
                        <tr>
                            <td>2025-05-23</td>
                            <td>BEARISH</td>
                            <td>72%</td>
                            <td>20.3</td>
                            <td>$514.84</td>
                            <td>$508.34</td>
                            <td class="positive">-1.26%</td>
                            <td class="positive">$+353.80</td>
                            <td style="font-size: 0.85em;">QQQ opened with a significant gap down of -$6.23 (-1.21%) from previous close of $513.87 to $506.18. Despite the recovery attempt from the session low of $505.58 to current price around $509.01, price...</td>
                        </tr>
                        <tr>
                            <td>2025-05-27</td>
                            <td>BULLISH</td>
                            <td>78%</td>
                            <td>22.3</td>
                            <td>$517.85</td>
                            <td>$521.32</td>
                            <td class="positive">+0.67%</td>
                            <td class="positive">$+17.99</td>
                            <td style="font-size: 0.85em;">Strong gap-up opening from previous close of $508.34 to $515.59 (+1.43%) indicates institutional buying pressure. Price has maintained upward momentum throughout pre-market, establishing higher lows c...</td>
                        </tr>
                        <tr>
                            <td>2025-05-29</td>
                            <td>BEARISH</td>
                            <td>72%</td>
                            <td>19.3</td>
                            <td>$530.47</td>
                            <td>$517.65</td>
                            <td class="positive">-2.42%</td>
                            <td class="positive">$+913.42</td>
                            <td style="font-size: 0.85em;">QQQ opened significantly below previous close of $528.45, gapping down $2.12 to $526.33 and continuing to sell off throughout pre-market and early session. Price has declined from the open high of $52...</td>
                        </tr>
                        <tr>
                            <td>2025-06-02</td>
                            <td>BULLISH</td>
                            <td>72%</td>
                            <td>18.6</td>
                            <td>$515.62</td>
                            <td>$522.25</td>
                            <td class="positive">+1.29%</td>
                            <td class="positive">$+312.33</td>
                            <td style="font-size: 0.85em;">QQQ opened with a gap up from previous close of $518.49 to $517.24 pre-market, then rallied strongly to $521.35 in the first 10 minutes before consolidating. Current price at $520.49 is trading above ...</td>
                        </tr>
                        <tr>
                            <td>2025-06-03</td>
                            <td>BULLISH</td>
                            <td>72%</td>
                            <td>18.4</td>
                            <td>$521.01</td>
                            <td>$527.41</td>
                            <td class="positive">+1.23%</td>
                            <td class="positive">$+325.09</td>
                            <td style="font-size: 0.85em;">Strong bullish price action from previous session's close of $522.25 to current pre-market high of $527.63 (+1.03% gain). Price has established a clear ascending pattern with higher highs and higher l...</td>
                        </tr>
                        <tr>
                            <td>2025-06-05</td>
                            <td>BULLISH</td>
                            <td>72%</td>
                            <td>17.6</td>
                            <td>$530.07</td>
                            <td>$523.67</td>
                            <td class="negative">-1.21%</td>
                            <td class="negative">$-321.34</td>
                            <td style="font-size: 0.85em;">Price opened at 530.18 above previous close of 528.40 (+0.34% gap up), establishing bullish overnight sentiment. After initial volatility and a pullback to 527.27 support, price recovered strongly and...</td>
                        </tr>
                        <tr>
                            <td>2025-06-06</td>
                            <td>BULLISH</td>
                            <td>72%</td>
                            <td>18.5</td>
                            <td>$526.55</td>
                            <td>$530.79</td>
                            <td class="positive">+0.81%</td>
                            <td class="positive">$+59.77</td>
                            <td style="font-size: 0.85em;">QQQ opened at 530.00 on 2025-06-06, gapping up $6.33 (+1.21%) from previous close of 523.67. Price action shows consolidation between 529.30 and 531.71 with buyers defending the 529.00-529.30 support ...</td>
                        </tr>
                        <tr>
                            <td>2025-06-12</td>
                            <td>BULLISH</td>
                            <td>72%</td>
                            <td>17.3</td>
                            <td>$529.73</td>
                            <td>$530.07</td>
                            <td class="negative">+0.06%</td>
                            <td class="negative">$-314.14</td>
                            <td style="font-size: 0.85em;">Price action shows clear bullish momentum from previous close of 531.24 to current level around 534.12. The session opened with a small gap up and has established a series of higher lows throughout pr...</td>
                        </tr>
                        <tr>
                            <td>2025-06-13</td>
                            <td>BULLISH</td>
                            <td>72%</td>
                            <td>18.0</td>
                            <td>$526.45</td>
                            <td>$526.98</td>
                            <td class="negative">+0.10%</td>
                            <td class="negative">$-221.17</td>
                            <td style="font-size: 0.85em;">Strong V-shaped recovery from pre-market low of $526.14 to current $531.02, representing a $4.88 rally (0.93%). Price has reclaimed previous day's close ($530.07) and is consolidating above it. The st...</td>
                        </tr>
                        <tr>
                            <td>2025-06-16</td>
                            <td>BULLISH</td>
                            <td>72%</td>
                            <td>20.8</td>
                            <td>$530.20</td>
                            <td>$530.46</td>
                            <td class="negative">+0.05%</td>
                            <td class="negative">$-275.42</td>
                            <td style="font-size: 0.85em;">QQQ gapped up significantly from Friday's close of $526.98 to open at $530.50 (+0.67%), demonstrating strong overnight bullish sentiment. Price rallied to $535.35 intraday high (+1.59% from previous c...</td>
                        </tr>
                        <tr>
                            <td>2025-06-18</td>
                            <td>BULLISH</td>
                            <td>72%</td>
                            <td>21.6</td>
                            <td>$530.46</td>
                            <td>$528.96</td>
                            <td class="negative">-0.28%</td>
                            <td class="negative">$-321.58</td>
                            <td style="font-size: 0.85em;">QQQ opened at 530.10 on 6/18, creating a +2.29 gap above previous close of 527.81. Price has established a clear uptrend during pre-market, rallying from 528.59 low to 532.45 high (+3.86 points, +0.73...</td>
                        </tr>
                        <tr>
                            <td>2025-06-24</td>
                            <td>BULLISH</td>
                            <td>72%</td>
                            <td>19.8</td>
                            <td>$537.47</td>
                            <td>$540.18</td>
                            <td class="negative">+0.50%</td>
                            <td class="negative">$-7.78</td>
                            <td style="font-size: 0.85em;">Strong gap-up open from previous close of $535.72 to $536.89 (+$1.17, +0.22%) indicates overnight institutional buying. Price has steadily climbed through pre-market session from $537.12 to current $5...</td>
                        </tr>
                        <tr>
                            <td>2025-06-26</td>
                            <td>BULLISH</td>
                            <td>72%</td>
                            <td>16.8</td>
                            <td>$541.00</td>
                            <td>$546.38</td>
                            <td class="positive">+0.99%</td>
                            <td class="positive">$+210.10</td>
                            <td style="font-size: 0.85em;">Price gapped up +$2.22 (+0.41%) from previous close of $541.13 to open at $543.35. Throughout pre-market session, price has established a clear uptrend from $542.50 low to current $544.82 high, making...</td>
                        </tr>
                        <tr>
                            <td>2025-06-27</td>
                            <td>BULLISH</td>
                            <td>72%</td>
                            <td>16.6</td>
                            <td>$547.67</td>
                            <td>$547.59</td>
                            <td class="negative">-0.01%</td>
                            <td class="negative">$-331.90</td>
                            <td style="font-size: 0.85em;">QQQ gapped up $0.88 from previous close of $546.38 to open at $547.26, confirming overnight bullish sentiment. Price has established a clear uptrend during pre-market, rallying from $547.26 to a high ...</td>
                        </tr>
                        <tr>
                            <td>2025-07-01</td>
                            <td>BEARISH</td>
                            <td>72%</td>
                            <td>16.7</td>
                            <td>$550.56</td>
                            <td>$547.36</td>
                            <td class="positive">-0.58%</td>
                            <td class="positive">$+30.36</td>
                            <td style="font-size: 0.85em;">Price opened at 549.73 (gap down from previous close of 551.56, -$1.83 or -0.33%) and has continued lower throughout pre-market and early session. Session low of 544.66 represents a -1.25% decline fro...</td>
                        </tr>
                        <tr>
                            <td>2025-07-02</td>
                            <td>BULLISH</td>
                            <td>72%</td>
                            <td>16.8</td>
                            <td>$547.87</td>
                            <td>$550.94</td>
                            <td class="negative">+0.56%</td>
                            <td class="negative">$-38.02</td>
                            <td style="font-size: 0.85em;">Price opened at 546.16 (gap down from previous close 547.36) but has steadily recovered throughout pre-market, now trading at 550.42. The consistent higher lows pattern from 546.12 low to current leve...</td>
                        </tr>
                        <tr>
                            <td>2025-07-03</td>
                            <td>BULLISH</td>
                            <td>72%</td>
                            <td>16.6</td>
                            <td>$552.05</td>
                            <td>$555.81</td>
                            <td class="positive">+0.68%</td>
                            <td class="positive">$+46.47</td>
                            <td style="font-size: 0.85em;">Strong gap-up open from previous close of $550.94 to $553.18 (+$2.24, +0.41%) indicates overnight bullish sentiment. Price has steadily climbed from gap open to current $556.57, establishing higher lo...</td>
                        </tr>
                        <tr>
                            <td>2025-07-14</td>
                            <td>BULLISH</td>
                            <td>72%</td>
                            <td>16.4</td>
                            <td>$552.51</td>
                            <td>$555.68</td>
                            <td class="negative">+0.57%</td>
                            <td class="negative">$-66.81</td>
                            <td style="font-size: 0.85em;">Price opened at 553.99 and has steadily climbed to 555.73 (+0.31% from open, +0.40% from previous close of 553.50). The session shows a clear stair-step pattern of higher lows: 551.63 (06:45) → 553.15...</td>
                        </tr>
                        <tr>
                            <td>2025-07-17</td>
                            <td>BULLISH</td>
                            <td>72%</td>
                            <td>17.2</td>
                            <td>$557.62</td>
                            <td>$562.37</td>
                            <td class="positive">+0.85%</td>
                            <td class="positive">$+99.13</td>
                            <td style="font-size: 0.85em;">QQQ opened at 558.02 and has steadily climbed to 561.82 over the pre-market session, gaining approximately $5.26 (+0.95%) from the previous close of 556.56. Price action shows consistent higher lows a...</td>
                        </tr>
                        <tr>
                            <td>2025-08-01</td>
                            <td>BEARISH</td>
                            <td>72%</td>
                            <td>16.7</td>
                            <td>$562.78</td>
                            <td>$553.05</td>
                            <td class="positive">-1.73%</td>
                            <td class="positive">$+654.11</td>
                            <td style="font-size: 0.85em;">QQQ opened with a significant gap down of $4.78 (-0.85%) from previous close of $563.61 to $558.83. Despite an intraday recovery attempt from the session low of $553.48 back to $556.96, price remains ...</td>
                        </tr>
                        <tr>
                            <td>2025-08-04</td>
                            <td>BULLISH</td>
                            <td>72%</td>
                            <td>20.4</td>
                            <td>$557.06</td>
                            <td>$564.97</td>
                            <td class="positive">+1.42%</td>
                            <td class="positive">$+459.46</td>
                            <td style="font-size: 0.85em;">QQQ opened at 559.05 (gap up +6.00 from previous close of 553.05) and has maintained upward momentum throughout pre-market, currently at 563.22. Price has established a clear uptrend with higher highs...</td>
                        </tr>
                        <tr>
                            <td>2025-08-06</td>
                            <td>BULLISH</td>
                            <td>72%</td>
                            <td>17.9</td>
                            <td>$562.34</td>
                            <td>$568.00</td>
                            <td class="positive">+1.01%</td>
                            <td class="positive">$+259.30</td>
                            <td style="font-size: 0.85em;">Strong gap-up of $2.87 (+0.51%) above previous close indicates overnight institutional buying. Pre-market session shows consistent higher lows with price advancing from $561.11 to $565.92 (+0.86%). Vo...</td>
                        </tr>
                        <tr>
                            <td>2025-08-12</td>
                            <td>BULLISH</td>
                            <td>72%</td>
                            <td>16.2</td>
                            <td>$573.31</td>
                            <td>$580.65</td>
                            <td class="positive">+1.28%</td>
                            <td class="positive">$+417.71</td>
                            <td style="font-size: 0.85em;">Price opened at 575.16 on 2025-08-12 and has steadily climbed to 578.66, representing a +3.59 gain (+0.62%) from previous close of 572.71. The session shows consistent higher lows pattern from the 573...</td>
                        </tr>
                        <tr>
                            <td>2025-08-22</td>
                            <td>BULLISH</td>
                            <td>72%</td>
                            <td>16.6</td>
                            <td>$563.01</td>
                            <td>$572.64</td>
                            <td class="positive">+1.71%</td>
                            <td class="positive">$+622.89</td>
                            <td style="font-size: 0.85em;">Strong bullish gap-up from previous close of $564.06 to current trading around $571.22. The 7:00 AM candle showed explosive momentum with a $5.24 range (564.75-571.20) on volume of 3.6M shares - indic...</td>
                        </tr>
                        <tr>
                            <td>2025-10-01</td>
                            <td>BULLISH</td>
                            <td>72%</td>
                            <td>16.3</td>
                            <td>$596.88</td>
                            <td>$603.44</td>
                            <td class="positive">+1.10%</td>
                            <td class="positive">$+282.57</td>
                            <td style="font-size: 0.85em;">Price action shows strong bullish momentum from session open. QQQ opened at 597.17 and has steadily climbed to 601.58, gaining approximately 4.40 points (+0.73%) from previous close of 598.75. The ses...</td>
                        </tr>
                        <tr>
                            <td>2025-10-06</td>
                            <td>BULLISH</td>
                            <td>72%</td>
                            <td>16.6</td>
                            <td>$604.50</td>
                            <td>$606.77</td>
                            <td class="negative">+0.38%</td>
                            <td class="negative">$-89.00</td>
                            <td style="font-size: 0.85em;">QQQ gapped up significantly from Friday's close of $602.97 to open at $608.45 (+0.91%), indicating strong overnight bullish sentiment. Price has consolidated in a tight range between $606.09-$608.62 t...</td>
                        </tr>
                        <tr>
                            <td>2025-10-08</td>
                            <td>BULLISH</td>
                            <td>72%</td>
                            <td>17.2</td>
                            <td>$605.48</td>
                            <td>$612.63</td>
                            <td class="positive">+1.18%</td>
                            <td class="positive">$+396.41</td>
                            <td style="font-size: 0.85em;">Price gapped up from previous close of 604.20 to open at 605.41, representing a +1.21 point gap (+0.20%). Pre-market price action shows consistent higher lows from 605.26 to 609.50, with price current...</td>
                        </tr>
                        <tr>
                            <td>2025-10-10</td>
                            <td>BEARISH</td>
                            <td>72%</td>
                            <td>16.4</td>
                            <td>$611.56</td>
                            <td>$589.93</td>
                            <td class="positive">-3.54%</td>
                            <td class="positive">$+1,836.76</td>
                            <td style="font-size: 0.85em;">Strong bearish momentum evident from significant price drop. QQQ opened at 611.40 and has fallen to 598.81, a decline of approximately $12.59 (-2.06%) from open. The 07:55-08:00 candles showed massive...</td>
                        </tr>
                        <tr>
                            <td>2025-10-13</td>
                            <td>BULLISH</td>
                            <td>72%</td>
                            <td>21.7</td>
                            <td>$598.17</td>
                            <td>$601.81</td>
                            <td class="positive">+0.61%</td>
                            <td class="positive">$+18.80</td>
                            <td style="font-size: 0.85em;">QQQ opened Monday's pre-market session at $599.68, gapping up $9.75 (+1.65%) from Friday's close of $589.93. The gap-up demonstrates strong overnight buying pressure following Friday's sharp selloff (...</td>
                        </tr>
                        <tr>
                            <td>2025-10-20</td>
                            <td>BULLISH</td>
                            <td>72%</td>
                            <td>20.8</td>
                            <td>$607.30</td>
                            <td>$612.06</td>
                            <td class="positive">+0.78%</td>
                            <td class="positive">$+138.32</td>
                            <td style="font-size: 0.85em;">Strong gap up from previous close ($604.99) to current pre-market levels ($611.78). Price opened at $607.14 and has steadily climbed to $611.78, establishing a clear uptrend with higher highs and high...</td>
                        </tr>
                        <tr>
                            <td>2025-10-22</td>
                            <td>BEARISH</td>
                            <td>72%</td>
                            <td>17.9</td>
                            <td>$611.60</td>
                            <td>$604.31</td>
                            <td class="positive">-1.19%</td>
                            <td class="positive">$+399.02</td>
                            <td style="font-size: 0.85em;">Price opened at 610.82 and has declined to 605.14, representing a -0.93% intraday drop from previous close of 610.25. The session shows consistent lower highs (611.41 → 610.82 → 609.80 → 607.44) and l...</td>
                        </tr>
                        <tr>
                            <td>2025-10-23</td>
                            <td>BULLISH</td>
                            <td>72%</td>
                            <td>18.6</td>
                            <td>$607.33</td>
                            <td>$611.75</td>
                            <td class="positive">+0.73%</td>
                            <td class="positive">$+107.30</td>
                            <td style="font-size: 0.85em;">Price opened at 604.91 and has steadily climbed to 609.32, representing a +0.83% gain from previous close of 604.31. The session shows consistent higher lows and higher highs pattern. Early momentum w...</td>
                        </tr>
                        <tr>
                            <td>2025-10-24</td>
                            <td>BULLISH</td>
                            <td>72%</td>
                            <td>17.3</td>
                            <td>$612.80</td>
                            <td>$617.52</td>
                            <td class="positive">+0.77%</td>
                            <td class="positive">$+81.02</td>
                            <td style="font-size: 0.85em;">QQQ gapped up significantly from previous close of $611.75 to open at $615.99 (+$4.24, +0.69%), establishing strong overnight bullish momentum. Price action throughout pre-market has been constructive...</td>
                        </tr>
                        <tr>
                            <td>2025-10-27</td>
                            <td>BULLISH</td>
                            <td>78%</td>
                            <td>16.4</td>
                            <td>$624.00</td>
                            <td>$628.94</td>
                            <td class="positive">+0.79%</td>
                            <td class="positive">$+116.30</td>
                            <td style="font-size: 0.85em;">Strong gap-up opening (+$7.00 / +1.13%) from previous close of $617.52 to pre-market open at $624.52, with sustained buying pressure throughout pre-market. Price has established a clear uptrend from $...</td>
                        </tr>
                        <tr>
                            <td>2025-11-04</td>
                            <td>BEARISH</td>
                            <td>72%</td>
                            <td>17.2</td>
                            <td>$625.00</td>
                            <td>$615.19</td>
                            <td class="positive">-1.57%</td>
                            <td class="positive">$+602.70</td>
                            <td style="font-size: 0.85em;">QQQ opened with a significant gap down of $8.50 (-1.35%) from previous close of $629.78 to $621.69. After initial bounce to $626.76 high (partial gap fill attempt), price has been in persistent downtr...</td>
                        </tr>
                        <tr>
                            <td>2025-11-05</td>
                            <td>BULLISH</td>
                            <td>72%</td>
                            <td>19.0</td>
                            <td>$615.84</td>
                            <td>$622.35</td>
                            <td class="positive">+1.06%</td>
                            <td class="positive">$+261.88</td>
                            <td style="font-size: 0.85em;">QQQ gapped up significantly from previous close of $615.19 to open at $617.52 (gap of +$2.33 or +0.38%). Price has maintained a steady uptrend throughout pre-market, rising from $617.52 to $624.45 wit...</td>
                        </tr>
                        <tr>
                            <td>2025-11-06</td>
                            <td>BEARISH</td>
                            <td>72%</td>
                            <td>18.0</td>
                            <td>$621.75</td>
                            <td>$613.36</td>
                            <td class="positive">-1.35%</td>
                            <td class="positive">$+487.65</td>
                            <td style="font-size: 0.85em;">Price opened at 621.79 (below previous close of 622.35) and has sold off sharply to 611.45, representing a 1.75% intraday decline. The selling pressure has been persistent with lower highs and lower l...</td>
                        </tr>
                        <tr>
                            <td>2025-11-07</td>
                            <td>BEARISH</td>
                            <td>72%</td>
                            <td>19.5</td>
                            <td>$612.12</td>
                            <td>$612.15</td>
                            <td class="negative">+0.00%</td>
                            <td class="negative">$-370.57</td>
                            <td style="font-size: 0.85em;">QQQ opened with a significant gap down of $5.05 (-0.82%) from previous close of $613.36 to $608.31. The session has shown persistent selling pressure with price declining from the opening high of $608...</td>
                        </tr>
                        <tr>
                            <td>2025-11-10</td>
                            <td>BULLISH</td>
                            <td>72%</td>
                            <td>19.1</td>
                            <td>$617.12</td>
                            <td>$623.82</td>
                            <td class="positive">+1.09%</td>
                            <td class="positive">$+308.43</td>
                            <td style="font-size: 0.85em;">QQQ opened with a significant gap up from previous close of $612.15 to $618.92 (+1.1% overnight gap). Early session showed bullish momentum pushing to session high of $622.04 before profit-taking pull...</td>
                        </tr>
                        <tr>
                            <td>2025-11-13</td>
                            <td>BEARISH</td>
                            <td>72%</td>
                            <td>17.5</td>
                            <td>$623.00</td>
                            <td>$608.52</td>
                            <td class="positive">-2.32%</td>
                            <td class="positive">$+1,070.90</td>
                            <td style="font-size: 0.85em;">QQQ gapped down significantly from previous close of $619.60, opening at $617.54 (gap of -$2.06 or -0.33%). Price immediately sold off in pre-market, reaching session low of $609.68. The entire sessio...</td>
                        </tr>
                        <tr>
                            <td>2025-11-14</td>
                            <td>BULLISH</td>
                            <td>72%</td>
                            <td>20.0</td>
                            <td>$606.00</td>
                            <td>$611.36</td>
                            <td class="positive">+0.88%</td>
                            <td class="positive">$+169.10</td>
                            <td style="font-size: 0.85em;">Strong gap-down recovery pattern observed. Price opened at 599.55 (gap down of $8.97 or -1.47% from previous close of 608.52) but has rallied aggressively throughout the session, reaching 612.62 - now...</td>
                        </tr>
                        <tr>
                            <td>2025-11-20</td>
                            <td>BEARISH</td>
                            <td>72%</td>
                            <td>23.7</td>
                            <td>$610.50</td>
                            <td>$586.82</td>
                            <td class="positive">-3.88%</td>
                            <td class="positive">$+1,948.40</td>
                            <td style="font-size: 0.85em;">Strong bearish price action from session open at 611.62 down to current 593.25, representing a -3.0% intraday decline. The overnight gap up from previous close of 609.54 to 611.62 has been completely ...</td>
                        </tr>
                        <tr>
                            <td>2025-11-24</td>
                            <td>BULLISH</td>
                            <td>72%</td>
                            <td>23.4</td>
                            <td>$596.00</td>
                            <td>$605.85</td>
                            <td class="positive">+1.65%</td>
                            <td class="positive">$+624.10</td>
                            <td style="font-size: 0.85em;">Strong gap-up opening from Friday close of $592.06 to Monday pre-market open of $595.28 (+$3.22, +0.54%). Price has established a clear uptrend through pre-market session, advancing from $595.28 to cu...</td>
                        </tr>
                        <tr>
                            <td>2025-11-25</td>
                            <td>BULLISH</td>
                            <td>72%</td>
                            <td>20.5</td>
                            <td>$604.50</td>
                            <td>$609.90</td>
                            <td class="positive">+0.89%</td>
                            <td class="positive">$+224.00</td>
                            <td style="font-size: 0.85em;">Price action shows strong recovery from pre-market low of 597.32 to current 606.74, demonstrating buyer commitment. The session opened with a gap down from previous close of 605.85 to 603.51, but buye...</td>
                        </tr>
                        <tr>
                            <td>2025-11-26</td>
                            <td>BULLISH</td>
                            <td>72%</td>
                            <td>18.6</td>
                            <td>$611.00</td>
                            <td>$615.20</td>
                            <td class="positive">+0.69%</td>
                            <td class="positive">$+50.10</td>
                            <td style="font-size: 0.85em;">QQQ opened with a strong gap up from previous close of $609.90 to $612.51, representing a +$2.61 (+0.43%) bullish gap. Price action throughout the pre-market session has been constructive, with a seri...</td>
                        </tr>
                        <tr>
                            <td>2025-11-28</td>
                            <td>BULLISH</td>
                            <td>72%</td>
                            <td>17.2</td>
                            <td>$615.42</td>
                            <td>$619.11</td>
                            <td class="positive">+0.60%</td>
                            <td class="positive">$+38.45</td>
                            <td style="font-size: 0.85em;">QQQ opened at 616.11 (gap up +0.91 from previous close of 615.20) and has maintained a bullish posture throughout pre-market. Price action shows higher lows pattern: 615.95 → 616.06 → 616.22 → 617.05 ...</td>
                        </tr>
                        <tr>
                            <td>2025-12-03</td>
                            <td>BULLISH</td>
                            <td>72%</td>
                            <td>16.6</td>
                            <td>$623.57</td>
                            <td>$622.93</td>
                            <td class="negative">-0.10%</td>
                            <td class="negative">$-377.44</td>
                            <td style="font-size: 0.85em;">QQQ opened at 619.62 on Dec 3rd, gapping up +2.24 (+0.36%) from previous close of 617.38. Price action shows consistent higher lows throughout the pre-market session, with price consolidating in the 6...</td>
                        </tr>
                        <tr>
                            <td>2025-12-17</td>
                            <td>BEARISH</td>
                            <td>72%</td>
                            <td>16.5</td>
                            <td>$612.86</td>
                            <td>$602.75</td>
                            <td class="positive">-1.65%</td>
                            <td class="positive">$+654.30</td>
                            <td style="font-size: 0.85em;">Price opened at 613.06 on 12/17 and has sold off aggressively to 604.15, representing a -1.45% decline from session high. The selling pressure accelerated between 07:35-08:00 with heavy volume (1.1M-1...</td>
                        </tr>
                        <tr>
                            <td>2025-12-19</td>
                            <td>BULLISH</td>
                            <td>72%</td>
                            <td>16.9</td>
                            <td>$612.23</td>
                            <td>$618.79</td>
                            <td class="positive">+1.07%</td>
                            <td class="positive">$+308.36</td>
                            <td style="font-size: 0.85em;">Strong overnight gap up from $608.98 to $611.95 (+$2.97, +0.49%) signals institutional bullish positioning ahead of the session. Price consolidated in the $614-617 range during pre-market, establishin...</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>


            <p style="margin: 20px; font-size: 1.1em; text-align: center;"><a href="/backtesting/ai-bias?key=ai-bias-2025" style="color: #667eea; text-decoration: none; font-weight: bold;">← Back to Main Report</a></p>
        </div>

        <div class="footer">
            <p><strong>AI Daily Bias 0DTE Options Strategy</strong></p>
            <p>Complete Trade Log | 93 Trades | 73.1% Win Rate | $34,160 Net Profit</p>
        </div>
    </div>
`;

const styles = `
    * {
        margin: 0;
        padding: 0;
        box-sizing: border-box;
    }

    body {
        font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif;
        background-image: url('/trading-background.jpg') !important;
        background-size: cover !important;
        background-position: center !important;
        background-attachment: fixed !important;
        background-repeat: no-repeat !important;
        line-height: 1.6;
        color: #333;
    }

    .ai-bias-trades-page {
        font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif;
        line-height: 1.6;
        color: #333;
        background-image: url('/trading-background.jpg') !important;
        background-size: cover !important;
        background-position: center !important;
        background-attachment: fixed !important;
        background-repeat: no-repeat !important;
        padding: 20px;
        min-height: 100vh;
    }

    .ai-bias-trades-page .container {
        max-width: 1400px;
        margin: 0 auto;
        background: white;
        box-shadow: 0 10px 40px rgba(0,0,0,0.2);
        border-radius: 12px;
        overflow: hidden;
    }

    .ai-bias-trades-page .header {
        background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
        color: white;
        padding: 40px;
        text-align: center;
    }

    .ai-bias-trades-page .header h1 {
        font-size: 2.5em;
        margin-bottom: 10px;
        font-weight: 700;
    }

    .ai-bias-trades-page .header .subtitle {
        font-size: 1.1em;
        opacity: 0.95;
    }

    .ai-bias-trades-page .content {
        padding: 40px;
    }

    .ai-bias-trades-page .section {
        margin-bottom: 50px;
    }

    .ai-bias-trades-page .section h2 {
        font-size: 2em;
        color: #667eea;
        margin-bottom: 20px;
        padding-bottom: 10px;
        border-bottom: 3px solid #667eea;
    }

    .ai-bias-trades-page .info-box {
        background: #e3f2fd;
        border-left: 4px solid #2196f3;
        padding: 20px;
        margin: 20px 0;
        border-radius: 4px;
    }

    .ai-bias-trades-page table {
        width: 100%;
        border-collapse: collapse;
        margin: 20px 0;
        background: white;
        box-shadow: 0 2px 8px rgba(0,0,0,0.1);
        border-radius: 8px;
        overflow: hidden;
    }

    .ai-bias-trades-page thead {
        background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
        color: white;
    }

    .ai-bias-trades-page th {
        padding: 15px;
        text-align: left;
        font-weight: 600;
        text-transform: uppercase;
        font-size: 0.9em;
        letter-spacing: 0.5px;
    }

    .ai-bias-trades-page td {
        padding: 12px 15px;
        border-bottom: 1px solid #eee;
    }

    .ai-bias-trades-page tbody tr:hover {
        background: #f8f9fa;
    }

    .ai-bias-trades-page .positive {
        color: #38ef7d;
        font-weight: 600;
    }

    .ai-bias-trades-page .negative {
        color: #f093fb;
        font-weight: 600;
    }

    .ai-bias-trades-page .footer {
        background: #2c3e50;
        color: white;
        padding: 30px 40px;
        text-align: center;
    }

    .ai-bias-trades-page .footer p {
        margin-bottom: 10px;
        opacity: 0.9;
    }

    .access-denied {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        min-height: 100vh;
        background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
        color: white;
        font-family: 'Segoe UI', system-ui, -apple-system, sans-serif;
    }

    .access-denied h1 {
        font-size: 2rem;
        margin-bottom: 1rem;
    }

    .loading {
        display: flex;
        align-items: center;
        justify-content: center;
        min-height: 100vh;
        background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
        color: white;
        font-family: 'Segoe UI', system-ui, -apple-system, sans-serif;
    }
`;

function AiBiasTradesLog() {
  const [searchParams] = useSearchParams();
  const [isValid, setIsValid] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const validateKey = async () => {
      const key = searchParams.get('key');

      if (!key) {
        setIsValid(false);
        setIsLoading(false);
        return;
      }

      try {
        const response = await fetch(`/api/validate-ai-bias-key?key=${encodeURIComponent(key)}`);
        const data = await response.json();
        setIsValid(data.valid);
      } catch (error) {
        setIsValid(false);
      }

      setIsLoading(false);
    };

    validateKey();
  }, [searchParams]);

  if (isLoading) {
    return (
      <>
        <style>{styles}</style>
        <div className="loading">
          <p>Validating access...</p>
        </div>
      </>
    );
  }

  if (!isValid) {
    return (
      <>
        <style>{styles}</style>
        <div className="access-denied">
          <h1>Access Denied</h1>
          <p>Invalid or missing access key.</p>
        </div>
      </>
    );
  }

  return (
    <>
      <style>{styles}</style>
      <div className="ai-bias-trades-page" dangerouslySetInnerHTML={{ __html: resultsHtml }} />
    </>
  );
}

export default AiBiasTradesLog;
